module.exports = __webpack_public_path__ + "img/create-wallet.73282ac1.png";